/* eslint-disable react-refresh/only-export-components */
import { createContext, ReactNode } from 'react'

import { useAppDispatch } from '../hooks/useAppDispatch'
import { useLocalStorage } from '../hooks/useLocalStorage'
import { persistor } from '../reducers'
import { setIsAuthenticated, setProfile } from '../reducers/authReducer'
import { JWT_TOKEN_KEY_NAME } from '../utils/constants'

type AuthContextDataProps = {
  signOut: () => void
}

type AuthContextProviderProps = {
  children: ReactNode
}

export const AuthContext = createContext<AuthContextDataProps>(
  {} as AuthContextDataProps,
)

export function AuthProvider({ children }: AuthContextProviderProps) {
  const [, , removeToken] = useLocalStorage(JWT_TOKEN_KEY_NAME)

  const dispatch = useAppDispatch()

  function signOut() {
    removeToken()
    dispatch(setIsAuthenticated(false))
    dispatch(setProfile(null))
    persistor.purge()
  }

  return (
    <AuthContext.Provider
      value={{ signOut }}
    >
      {children}
    </AuthContext.Provider>
  )
}
